import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-[#264790] to-[#1B3268] text-white pt-16 pb-10">
      <div className="container mx-auto px-4 grid md:grid-cols-4 gap-10">

        {/* Logo + Description */}
        <div>
          <img src="/logo.png" alt="SvaLearn Logo" className="h-20 mb-4" />
          <p className="text-sm leading-relaxed text-white/90">
            🎓 Sva Learn is an AI-driven eLearning platform offering chapter-wise resources like lesson notes, flash cards, mind maps, quizzes, and more. It personalizes your learning journey, making studying smarter, faster, and more engaging.
          </p>
          <div className="flex gap-4 mt-6">
            <a
              href="https://facebook.com"
              title="Follow us on Facebook"
              className="hover:text-[#ffe] transition-transform hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com"
              title="Follow us on Twitter"
              className="hover:text-[#ffe] transition-transform hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://linkedin.com"
              title="Connect on LinkedIn"
              className="hover:text-[#ffe] transition-transform hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://instagram.com"
              title="Follow us on Instagram"
              className="hover:text-[#ffe] transition-transform hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-semibold mb-4 underline underline-offset-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/subjects">Browse Subjects</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/terms">Terms and Conditions</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/refund">Refund Policy</Link></li>
          </ul>
        </div>

        {/* Features */}
        <div>
          <h4 className="text-lg font-semibold mb-4 underline underline-offset-4">Unique Features</h4>
          <p className="text-sm mb-4">Stay ahead with the features from Sva Learn.</p>
            <li><Link to="/">Lesson Notes</Link></li>
            <li><Link to="/">Takeaways</Link></li>
            <li><Link to="/">Flash Cards</Link></li>
            <li><Link to="/">Mind Maps</Link></li>
            <li><Link to="/">Quizzes</Link></li>
            <li><Link to="/">AI Chatbot</Link></li>
            <li><Link to="/">Solved Question Papers</Link></li>
        </div>

        {/* Gallery Thumbs */}
        <div>
          <h4 className="text-lg font-semibold mb-4 underline underline-offset-4">Affiliation Boards</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="https://kseeb.karnataka.gov.in/schoolLogin/views/loginpage.aspx" target="_blank">KSEAB</Link></li>
            <li><Link to="http://www.rguhs.ac.in/" target="_blank">RGUHS</Link></li>
            <li><Link to="https://vtu.ac.in/" target="_blank">VTU</Link></li>
            <li><Link to="https://bangaloreuniversity.karnataka.gov.in/" target="_blank">Bangalore University</Link></li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="mt-12 border-t border-white/20 pt-6 text-sm flex flex-col sm:flex-row justify-between items-center px-4">
        <p className="text-white/80">&copy; {new Date().getFullYear()} Sva Learn. All rights reserved.</p>
        <div className="flex gap-4 mt-4 sm:mt-0">
          <Link to="/privacy" className="hover:underline">Privacy & Policy</Link>
          <span className="opacity-60">||</span>
          <Link to="/terms" className="hover:underline">Terms & Conditions</Link>
        </div>
      </div>
    </footer>
  );
}
